var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useStylesHook } from "../hooks/useStylesHook";
import { TMS_THEME } from "../theming/theming";
export var useAgendaStyles = function (row) {
    return useStylesHook({
        indicatorContainer: {
            width: 32,
        },
        indicator: __assign({ height: 9, width: 9, borderRadius: "50%", display: "inline-block", marginRight: 8, marginTop: 5 }, getAttributes(row.indicator)),
        datetimeContainer: {
            width: 144,
        },
        elementHeight: {
            height: 16,
        },
        metaInformation: {
            fontSize: 10,
            color: "#687C8A",
        },
        arrowContainer: {
            width: 24,
            textAlign: "center",
        },
        subSectionContainer: {
            padding: "12px 12px 12px 16px",
            backgroundColor: TMS_THEME.palette.gray.mist.color,
        },
    });
};
var getAttributes = function (indicator) {
    var backgroundColor = "transparent";
    if (indicator === "green")
        backgroundColor = TMS_THEME.palette.success.base.color;
    if (indicator === "red")
        backgroundColor = TMS_THEME.palette.error.base.color;
    if (indicator === "lightgrey")
        backgroundColor = TMS_THEME.palette.gray.smoke.color;
    return {
        border: indicator === "dotted"
            ? "1px dotted ".concat(TMS_THEME.palette.gray.smoke.color)
            : {},
        backgroundColor: backgroundColor,
    };
};
